<template>
  <div class="poster-wrap">
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true">添加配置</el-button>
    <el-dialog title="添加配置" width="600px" :visible.sync="dialogVisible">
      <el-form ref="forms" label-width="100px">
        <el-form-item label="币种：" prop="coinType">
            <el-select v-model="coinType">
            <el-option v-for="item in coinTypeList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="持仓量：" prop="amount">
          <el-input-number v-model="amount"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      dialogVisible: false,
      coinType: "",
      amount: ""
    };
  },
    computed: {
    ...mapState("chatroom", ["coinTypeList"]),

  },
  methods: {
    ...mapActions("chatroom", ["uploadPoster"]),
    handleSave() {
      this.uploadPoster({ coinType: this.coinType, amount: this.amount })
        .then(res => {
          this.$message.success("操作成功！");
          this.$emit("refresh");
        })
        .finally(() => {
          this.dialogVisible = false;
        });
    }
  }
};
</script>
<style lang="less">
</style>
